import { internalLogger } from '../../../interface/v1/clientOsLogger';
import {
  DataCollectionPlugin,
  DataCollectionService,
  JWebWindow
} from '../types';
import { jWebStates } from '../Initializer';
import { JWebCoreFacade } from './JWebCoreFacade';
// eslint-disable-next-line no-restricted-imports
import { getDataCollectionService as getDataCollectionServiceImport } from '@jarvis/web-data-collection';

/**
 * Facade for DataCollection operations (Web only?)
 */
export class DataCollectionFacade {
  /**
   * Get the DataCollection service
   // TODO: why this method is needed?
   */
  public static async getDataCollectionService(): Promise<
    DataCollectionService | undefined
  > {
    if (!(await JWebCoreFacade.isNative())) {
      // Was DataCollection installed?
      await DataCollectionFacade.isDataCollectionReady();

      return await getDataCollectionServiceImport();
    }
    return undefined;
  }

  /**
   * Get the DataCollection plugin
   */
  private static async getDataCollectionPlugin(): Promise<
    DataCollectionPlugin | undefined
  > {
    await DataCollectionFacade.isDataCollectionReady();

    const windowDataCollection: DataCollectionPlugin = (window as JWebWindow)
      ?.JWeb?.Plugins?.DataCollection;
    if (!windowDataCollection) {
      internalLogger?.error(
        'Unable to obtain DataCollection (missing some JWeb plugin)'
      );
    }
    return windowDataCollection;
  }
  /**
   * A promise that resolves to true if the DataCollection is ready, otherwise false.
   */
  private static async isDataCollectionReady(): Promise<boolean> {
    // Is Jweb ready?
    await jWebStates.JWebLibrary;

    // Is the plugins registered?
    await jWebStates.defaultPluginsRegistered;

    // Was DataCollection installed?
    await jWebStates.plugins.DataCollection;
    return true;
  }
}
